import React, { useMemo } from 'react';

// Utils
import { useImageHandler } from 'utils/custom_hooks';

// Component
import PriceContainer from 'components/PriceContainer';
import Button from 'components/Button';
import { BUTTON_TYPE } from 'constants/button';
import { SubHeading, TextBody } from 'components/Typography/General';

const CardForBundle = ({ data, onClick }) => {
  const memoizedOptionList = useMemo(
    () => [data?.courseOrganizer?.logo, data?.courseOrganizer?.companyLogo],
    [data?.courseOrganizer?.logo, data.courseOrganizer?.companyLogo]
  );
  const { currentImage, handleImageToDefault } = useImageHandler({
    optionList: memoizedOptionList,
    data: data,
  });

  return (
    <div className="col-md-6 col-lg-4 mt-0">
      <div className="card-bundle-wrapper">
        <div className="card-bundle-image-container">
          <img className="card-bundle-image" src={data.picture} alt={data.courseTitle} />
        </div>

        <div className="card-bundle-user-picture-container">
          <div className="user-picture-container course-logo">
            <img
              className="card-bundle-user-picture"
              src={currentImage}
              onError={() => handleImageToDefault()}
              alt={data.courseOrganizer?.name}
            />
          </div>
        </div>
        <SubHeading variety={3} className="card-bundle-title">
          {data.courseTitle}
        </SubHeading>
        <TextBody
          variety={4}
          className="card-bundle-desc"
          dangerouslySetInnerHTML={{ __html: data.shortDesc }}
        ></TextBody>
        <div className="d-flex justify-content-between mt-4">
          <p className="card-bundle-user-name">{data.courseOrganizer?.name}</p>
          <PriceContainer
            className="mb-3"
            variableDiscount={[parseFloat(data.discount?.['$numberDecimal']), parseFloat(data.discount)]}
            variablePrice={[data.price['$numberDecimal'], data.price]}
            courseOrganizer={data.courseOrganizer.code}
            isSmall
          />
        </div>

        <Button type={BUTTON_TYPE.secondary} onClick={() => onClick()} className="card-bundle-button p-0 mt-0">
          More Information
        </Button>
      </div>
    </div>
  );
};

export default CardForBundle;
